// Custom Swiper build — only the modules actually used across this theme are
// registered, instead of shipping every effect/module Swiper ships by default.
// Pinned to the 8.x line (not upgraded to 9+) because every `lazy: {...}`
// config across the theme relies on the classic Lazy module API
// (checkInView/loadOnTransitionStart/loadPrevNext/loadPrevNextAmount), which
// was removed in Swiper 9 in favour of native `loading="lazy"`.
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  EffectFade,
  Thumbs,
  FreeMode,
  Zoom,
  Lazy,
} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs, FreeMode, Zoom, Lazy]);

window.swiper = Swiper;
